import { render } from "./agenceDetail.vue?vue&type=template&id=c97eb3f8&scoped=true"
import script from "./agenceDetail.vue?vue&type=script&lang=js"
export * from "./agenceDetail.vue?vue&type=script&lang=js"

import "./agenceDetail.vue?vue&type=style&index=0&id=c97eb3f8&scoped=true&lang=css"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c97eb3f8"]])

export default __exports__